var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RPPDropdown',{attrs:{"value":_vm.rows,"options":_vm.rowsOptions,"optionLabel":"label","optionValue":"value"},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }